module.exports = __webpack_public_path__ + "static/img/logo_naptics.c77e7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_naptics.png
// module id = zzI4
// module chunks = 1